import { getCurrentAccount } from "@mirage/service-auth";
import { APIv2Callable } from "@mirage/service-dbx-api/service";
import { tagged } from "@mirage/service-logging";
import { BehaviorSubject } from "rxjs";
import { DashTrialInfoCache } from "./cache";
import { DashTrialInfo, fetchDashTrialInfoFromApi } from "./utils";
const SYNC_JOB_INTERVAL = 1000 * 60 * 2; // 2 minutes

const logger = tagged("trial-sync");

type DbxApiServiceContract = {
  callApiV2: APIv2Callable;
};
export class DashTrialInfoSync {
  private readonly cache: DashTrialInfoCache;
  private readonly currentDashTrialInfo: BehaviorSubject<
    DashTrialInfo | undefined
  >;
  private readonly dbxApiService: DbxApiServiceContract;
  private interval: NodeJS.Timeout | undefined = undefined;

  public constructor(
    cache: DashTrialInfoCache,
    dbxApiService: DbxApiServiceContract,
    currentDashTrialInfo: BehaviorSubject<DashTrialInfo | undefined>,
  ) {
    this.cache = cache;
    this.dbxApiService = dbxApiService;
    this.currentDashTrialInfo = currentDashTrialInfo;
  }

  public start() {
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.sync();
      }, SYNC_JOB_INTERVAL);
      return this.sync();
    }
  }

  public stop() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = undefined;
    }
  }

  private async sync() {
    // If user is not logged in, don't sync
    if (!(await getCurrentAccount())) {
      return;
    }
    const dashTrialInfo = await fetchDashTrialInfoFromApi(
      this.dbxApiService.callApiV2,
      logger,
    );
    if (dashTrialInfo) {
      await this.cache.setDashTrialInfo(dashTrialInfo);
      this.currentDashTrialInfo.next(dashTrialInfo);
    }
  }
}
